import { Link, useColorModeValue } from "@chakra-ui/react";
import React from "react";
import { Link as ReactLink } from "react-router-dom";

const NavLink = (props: { to: string, colorScheme?: string, text: string }) => {
    const color = props.colorScheme ?? 'gray';
    return (
        <Link as={ReactLink} to={props.to} key={props.to} colorScheme={props.colorScheme}
            px={2}
            py={1}
            rounded={'md'}
            _hover={{
                textDecoration: 'none',
                bg: useColorModeValue(color + '.200', color + '.700'),
            }}
        >
            {props.text}
        </Link>
    );
};

export default NavLink;
